import React, {Component} from 'react';
import './index.scss';
import {Loading} from '../../../../components/loading';
import {Button, Divider, List, message} from 'antd';
import AccountRepo from '../../../../repository/account';
import AccountDetail from "../detail";

class AccountList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      accounts: [],
      selectedAccount: null,
      detailsVisible: false,
    }
  }

  fetchAccounts = () => {
    if (!this.state.loading) {
      return;
    }

    AccountRepo.fetch(this.props.business.id).then(
      result => {
        this.setState({
          accounts: result.data.accounts || [],
          loading: false,
        })
      },
      error => {
        message.error("Error fetching accounts");
        console.log(error.response);
      },
    );
  };

  title = () => {
    return <p className='section-title'>
      Accounts
      <span className="fa-pull-right"><Button type="link" onClick={() => { }}> </Button></span>
    </p>
  };

  loading = () => {
    return (
      <Loading>{this.title()}</Loading>
    )
  };

  onClose = reload => {
    if (!reload) {
      return this.setState({
        selectedAccount: null,
        detailsVisible: false,
      });
    }

    this.setState({
      selectedAccount: null,
      detailsVisible: false,
      loading: true,
    }, () => {
      this.fetchAccounts();
    });
  };

  render() {
    const {business} = this.props;

    if (business.id) {
      this.fetchAccounts();
    }

    if (this.state.loading) {
      return this.loading();
    }

    return (
      <>
        {this.title()}
        <AccountDetail
          business={this.props.business}
          account={this.state.selectedAccount}
          visible={this.state.detailsVisible}
          close={this.onClose}
        />
        <List
          dataSource={this.state.accounts}
          bordered
          renderItem={item => (
            <List.Item key={item.id} actions={[<Button onClick={() => {
              this.setState({
                selectedAccount: item,
                detailsVisible: true,
              })
            }}>details</Button>]}>
              <List.Item.Meta
                title={<>{item.alias} <Divider type='vertical' /> {item.region_id}</>}
                description={<a href={item.url} rel="noopener noreferrer" target="_blank">{item.url}</a>}
              />
            </List.Item>
          )}
        />
      </>
    )
  }
}

export default AccountList;